import React, { useState } from 'react';
import CircularProgress from '@mui/material/CircularProgress';
import { Button } from './Ui';

const SubmitButton = ({
  name = 'Submit',
  size = 'sm',
  isSubmitting = false, 
}) => {
  return (
    <Button
      type="submit"
      size={size}
      disabled={isSubmitting}
      startIcon={isSubmitting ? <CircularProgress size={14} color="inherit" /> : undefined}
    >
      <span className="capitalize">{name}</span>
    </Button>
  );
};

export default SubmitButton;